import React from "react";
import { Select,message } from "antd";
import "./currency-converter.scss"
import { PreferredCurrency,PreferredCurrencyKazakh } from "../../constants/commonConstants";
import * as masterDataService from "../../service/masterDataService";
const CurrencyConverter = (props) => {

    const handleToCurrencyChange = (val, option) => {
        if(val){
            if(props.isRequireLoading==true){
                props.exchangeRateWaiter(true);
            }
            masterDataService.GetTurkeyExchangeRate(props?.isBookNow ? props.preferredCurrency :val,props?.isBookNow ? val : props.preferredCurrency,props?.country)
            .then((response)=>{
                    if(props.isRequireLoading==true){
                        props.exchangeRateWaiter(false);
                    }
                if(response.data.status==200){
                    props.onChange({"selectedCurrency": val ,"exchangeRate": response.data.data.exchange_rate})
                }else{
                    message.error("Error occured while fetching exchange rate.");
                }
            }).catch((error)=>{
                if(props.isRequireLoading==true){
                    props.exchangeRateWaiter(false);
                }
                message.error("Error occured while fetching exchange rate.")
            })
        }
        else {
            props.onChange({"selectedCurrency": null ,"exchangeRate": 0})
        }
    }
    //TODO Require changes for Kazakh currencyoption
    return (
        <>
            <Select disabled={props.isDisabled} showSearch={false} className='currency-select' size="large"
                style={{ width:props?.width ? "40%":"100%",marginLeft:"10px" }}
                options={props?.country=='Kazakhstan' ? PreferredCurrencyKazakh: PreferredCurrency}
                placeholder="Preferred Currency"
                defaultValue={props?.defaultValue?.selectedCurrency ? props?.defaultValue?.selectedCurrency : props.defaultValue}
                value={props?.defaultValue?.selectedCurrency ? props?.defaultValue?.selectedCurrency : props?.value?.selectedCurrency}
                filterOption={(input, option) =>
                    (option?.value ?? '').toLowerCase().includes(input.toLowerCase())}
                onChange={(val, option) => handleToCurrencyChange(val, option)}>
            </Select>
        </>
    )
}

export default CurrencyConverter;